export default __webpack_public_path__ + "static/media/celebrate.baf7577d49379c4c88f588a5ae043b75.svg";